import React from 'react'
import {
  SelectInput,
  TextInput,
  RadioButtonGroupInput,
  DateInput,
} from 'react-admin'
import { EventBriefQuestion } from 'services/api/entities/events/types/internal/services'
import { activityStatusChoices } from 'services/cfg/form'
import { useLangContext } from 'services/contexts/LangContext'
import { useKArrayInput } from 'services/hooks/useKArrayInput'
import { parseMultilangJSON } from 'services/utils/multilangParseWrite'
import LocalizedSelectInput from 'ui-shared/LocalizedFields/LocalizedSelectInput'
import TimePicker from 'ui-shared/WrappedInputs/TimePicker'

type Props = {
  source?: string
}

const EventBriefQuestionInput: React.FC<Props> = ({ source }) => {
  const { scopedFormData, kGetSource } =
    useKArrayInput<EventBriefQuestion>(source)
  const { currentLang } = useLangContext()

  const disabled = scopedFormData.status === 'inactive'

  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <h4>{parseMultilangJSON(scopedFormData?.text)[currentLang]}</h4>
        <SelectInput
          source={kGetSource!('status')}
          choices={activityStatusChoices}
          defaultValue={activityStatusChoices[1].id} // 'active'
        />
      </div>
      {scopedFormData?.type === 'freeText' && (
        <TextInput
          source={kGetSource('response')}
          label="form.fields.response"
          fullWidth
          disabled={disabled}
        />
      )}

      {scopedFormData?.type === 'boolean' && (
        <RadioButtonGroupInput
          source={kGetSource('response')}
          choices={[
            { id: 'no', name: 'No' },
            { id: 'yes', name: 'Yes' },
          ]}
          label="Response"
          row
          disabled={disabled}
        />
      )}

      {scopedFormData?.type === 'multiple' && (
        <LocalizedSelectInput
          source={kGetSource('response')}
          choices={scopedFormData?.options?.map((o) => ({
            id: o,
            name: o,
          }))}
          label="Response"
          forceDisabled={disabled}
        />
      )}

      {scopedFormData?.type === 'time' && (
        <TimePicker
          source={kGetSource('response')}
          label="Response"
          disabled={disabled}
        />
      )}

      {scopedFormData?.type === 'date' && (
        <DateInput
          source={kGetSource('response')}
          label="Response"
          disabled={disabled}
        />
      )}
    </React.Fragment>
  )
}

export default EventBriefQuestionInput
